import { getCalendarBackgroundHexCode } from "src/utils";
import { IGoogleCalendarCurrent, IGoogleCalendarIncomming } from "src/Interfaces/google-calendar";
import dayjs from "dayjs";

interface Model<I, C> {
  to: (data: C) => I | null;
  from?: (data: I) => C | C[] | null;
}

const ModelGoogleCalendar: Model<IGoogleCalendarIncomming, IGoogleCalendarCurrent> = {
  from: (data) => {
    if (!data) return null;

    const isAllDay = !!data.start.date;
    const start = dayjs(data.start.dateTimeRaw || data.start.date);
    const end = dayjs(data.end.dateTimeRaw || data.end.date);

    const base = {
      title: data.summary,
      key: data.id,
      isGoogleCalendar: true,
      backgroundColor: `${getCalendarBackgroundHexCode(`${data.colorId}`, "event")}`,
      color:
        getCalendarBackgroundHexCode(`${data.colorId}`, "event") !== "#C9E1FF" ? "#fff" : "#00479B",
    };

    const diffDays = end.diff(start, "day");

    if (isAllDay && diffDays > 1) {
      const entries: IGoogleCalendarCurrent[] = [];

      let current = start.clone();
      while (current.isBefore(end)) {
        entries.push({
          ...base,
          key: `${data.id}-${current.format("YYYY-MM-DD")}`,
          start: current.startOf("day").toDate(),
          end: current.endOf("day").toDate(),
        });
        current = current.add(1, "day");
      }

      return entries;
    }

    return {
      ...base,
      start: start.toDate(),
      end: end.toDate(),
    };
  },

  to: (data) => {
    if (!data) return null;
    return null;
  },
};

export default ModelGoogleCalendar;
